import { memo } from 'react';
import ColumnTitle from './ColumnTitle';
import { useConfigs } from './lib/config-context';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColumnHeader = /*#__PURE__*/memo(({
  columnData,
  onColumnCollapse,
  onHovered,
  collapsed,
  isBoardEmpty,
  backgroundColor
}) => {
  const {
    renderHeaderSummary
  } = useConfigs();
  const shouldRenderHeaderSummary = !collapsed && !isBoardEmpty && renderHeaderSummary;
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: backgroundColor,
    "data-test-id": "cdb-column-header-wrapper",
    children: [/*#__PURE__*/_jsx(ColumnTitle, {
      columnData: columnData,
      onColumnCollapse: onColumnCollapse,
      onHovered: onHovered,
      collapsed: collapsed
    }), shouldRenderHeaderSummary && /*#__PURE__*/_jsx(View, {
      textAlign: "center",
      padding: "200",
      marginBlockEnd: "0",
      "data-test-id": "cdb-column-header-summary",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndWidth: "100",
      backgroundColor: "fill-surface-default",
      children: renderHeaderSummary(columnData)
    })]
  });
});
export default ColumnHeader;